import RsPassport from './RsPassport/RsPassport';
import RsGNSS from './RsGNSS/RsGNSS';
import RsPressure from './RsPressure/RsPressure'
import RsNotice from './RsNotice/RsNotice'
import './RsConfig.css'

export default function RsConfig() {
    return(
        <div className="rsConfigCard">  
           <RsPassport  />
           <RsGNSS  />
           <RsPressure  />
           <RsNotice />
        </div>
    )
} 